// ==============================|| PRESET THEME - DEFAULT ||============================== //

export default function Default(colors) {
  const { blue, red, gold, cyan, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  // Grocery Management Theme Colors
  // Primary: Green (fresh produce, healthy, grocery-related)
  // Secondary: Orange (vibrant, fresh, food-related)
  const greenPrimary = {
    lighter: '#d1fae5', // green-100
    100: '#a7f3d0', // green-200
    200: '#6ee7b7', // green-300
    light: '#34d399', // green-400
    400: '#10b981', // green-500
    main: '#059669', // green-600 (primary main)
    dark: '#047857', // green-700
    700: '#065f46', // green-800
    darker: '#064e3b', // green-900
    900: '#022c22', // green-950
    contrastText
  };

  const orangeSecondary = {
    lighter: '#ffedd5', // orange-100
    100: '#fed7aa', // orange-200
    200: '#fdba74', // orange-300
    light: '#fb923c', // orange-400
    400: '#f97316', // orange-500
    main: '#ea580c', // orange-600 (secondary main)
    600: '#c2410c', // orange-700
    dark: '#9a3412', // orange-800
    800: '#7c2d12', // orange-900
    darker: '#431407', // orange-950
    A100: '#fff7ed', // orange-50
    A200: '#ffedd5', // orange-100
    A300: '#fed7aa', // orange-200
    contrastText
  };

  return {
    primary: greenPrimary,
    secondary: orangeSecondary,
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: gold[0],
      light: gold[3],
      main: gold[5],
      dark: gold[7],
      darker: gold[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: cyan[0],
      light: cyan[3],
      main: cyan[5],
      dark: cyan[7],
      darker: cyan[9],
      contrastText
    },
    success: {
      lighter: green[0],
      light: green[3],
      main: green[5],
      dark: green[7],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
}
